/* MemoHol – parakeet on the Shop search pill (README Oct 2 b; design: Curated Goods.dc.html dig() / measure()).
   Idle (empty + not focused): 2 pecks every 2.6s with 3 specks flying up (460ms). Blinks every 3.2s.
   Focus: 1 peck + ink border. Typing: slides (260ms) so the beak tip sits at 44px + text width (canvas measureText with
   the input's computed font, clamped to the pill) and pecks once per added character. No results: head tilts -14°
   (data-none, set by theme.js). Reduced motion: static bird, no pecks or specks. Decorative: aria-hidden, no pointer events. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canvas = document.createElement('canvas');
  const measure = (input, text) => {
    const ctx = canvas.getContext('2d'), cs = getComputedStyle(input);
    ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    return ctx.measureText(text).width;
  };

  function init(pill) {
    if (pill.dataset.birdReady) return;
    pill.dataset.birdReady = '1';
    const input = pill.querySelector('input[type="search"], input[name="q"]');
    const head = pill.querySelector('.sb__head'), eye = pill.querySelector('.sb__eye'), specks = pill.querySelector('.sb-specks');
    if (!input || !head) return;
    const timers = new Set();
    const later = (fn, ms) => { const id = setTimeout(() => { timers.delete(id); fn(); }, ms); timers.add(id); };

    const place = () => {
      const tip = Math.min(44 + measure(input, input.value), pill.clientWidth - 28);
      pill.style.setProperty('--sb-x', `${tip - 47}px`);
      pill.style.setProperty('--sb-tip', `${tip}px`);
    };
    const dig = (times) => {
      if (reduce.matches) return;
      for (let i = 0; i < times; i += 1) {
        const t = i * 240;
        later(() => { head.classList.add('is-peck'); specks.classList.remove('is-fly'); specks.classList.add('is-on'); }, t);
        later(() => { specks.classList.remove('is-on'); specks.classList.add('is-fly'); }, t + 30);
        later(() => head.classList.remove('is-peck'), t + 120);
      }
    };

    let prev = input.value;
    input.addEventListener('focus', () => { pill.classList.add('is-focus'); dig(1); });
    input.addEventListener('blur', () => pill.classList.remove('is-focus'));
    input.addEventListener('input', () => {
      const grew = input.value.length > prev.length;
      prev = input.value;
      place();
      if (grew) dig(1);
    });
    window.addEventListener('resize', place);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
    place();

    setInterval(() => {
      if (reduce.matches || document.hidden) return;
      eye.classList.add('is-blink');
      later(() => eye.classList.remove('is-blink'), 140);
    }, 3200);
    setInterval(() => {
      if (document.hidden || document.activeElement === input || input.value) return;
      dig(2);
    }, 2600);
  }

  const run = () => document.querySelectorAll('[data-search-bird]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
